import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const ECSearchIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.5 3.75C5.42893 3.75 3.75 5.42893 3.75 7.5C3.75 9.57107 5.42893 11.25 7.5 11.25C9.57107 11.25 11.25 9.57107 11.25 7.5C11.25 5.42893 9.57107 3.75 7.5 3.75ZM2.5 7.5C2.5 4.73858 4.73858 2.5 7.5 2.5C10.0498 2.5 12.1538 4.40856 12.4613 6.875H16.875C17.2202 6.875 17.5 7.15482 17.5 7.5C17.5 7.84518 17.2202 8.125 16.875 8.125H12.4613C12.1538 10.5914 10.0498 12.5 7.5 12.5C4.73858 12.5 2.5 10.2614 2.5 7.5ZM13.75 13.75C13.0596 13.75 12.5 14.3096 12.5 15C12.5 15.6904 13.0596 16.25 13.75 16.25C14.4404 16.25 15 15.6904 15 15C15 14.3096 14.4404 13.75 13.75 13.75ZM3.125 15.625H11.3288C11.6063 16.7033 12.5851 17.5 13.75 17.5C14.9149 17.5 15.8937 16.7033 16.1712 15.625H17.0312C17.2901 15.625 17.5 15.3452 17.5 15C17.5 14.6548 17.2901 14.375 17.0312 14.375H16.1712C15.8937 13.2967 14.9149 12.5 13.75 12.5C12.5851 12.5 11.6063 13.2967 11.3288 14.375H3.125C2.77982 14.375 2.5 14.6548 2.5 15C2.5 15.3452 2.77982 15.625 3.125 15.625Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default ECSearchIcon
